export const listParagraphPlugin: CKEDITOR.pluginDefinition = {
  init: (editor) => {
    let timeoutId = 0

    editor.on('change', () => {
      window.clearTimeout(timeoutId)

      timeoutId = window.setTimeout(() => {
        // editor.fire('lockSnapshot')

        const listItems = editor.editable().find('ol > li, ul > li')

        let bookmark: CKEDITOR.dom.bookmark[] | null = null

        for (let index = 0; index < listItems.count(); index++) {
          const listItem = listItems.getItem(index)

          const firstChildNodeName = listItem.$.firstChild?.nodeName

          if (firstChildNodeName !== 'P') {
            if (!bookmark) {
              bookmark = editor.getSelection().createBookmarks(true)
            }

            const paragraphEl = document.createElement('p')

            paragraphEl.innerHTML = listItem.$.innerHTML

            listItem.$.innerHTML = paragraphEl.outerHTML
          }
        }

        if (bookmark) {
          timeoutId = window.setTimeout(() => {
            if (!bookmark) {
              return
            }

            editor.getSelection().selectBookmarks(bookmark)
            // @ts-ignore
            editor.undoManager?.update()
            editor.fire('saveSnapshot')
            editor.fire('change')
          })
        }
      })
    })

    editor.on('destroy', () => {
      window.clearTimeout(timeoutId)
    })
  },
}
